<template>
  <section>
    <OrderDetail ref="orderDetail" :orderId="id ? String(id) : $route.query.id" />
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      :busiCode="busiCode || pageBusiCode"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </section>
</template>

<script>
import OrderDetail from '../../deal/orderDetailTab/orderDetail/orderDetail';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    OrderDetail,
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    busiCode: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    pageBusiCode () {
      const {
        orderState, orderUpdateState, joinAuditType,
      } = this.$route.query;
      if ((orderState === '1' && (orderUpdateState === null || orderUpdateState !== '5' && orderUpdateState !== '2'))) {
        return '300003';
      } else if ((orderUpdateState === '2' || orderUpdateState === '5') && joinAuditType !== '1') {
        return '300002';
      } else {
        return '300009';
      }
    },
  },
  methods: {
    getData () {
      this.$nextTick(() => {
        this.$refs.orderDetail.getData();
      });
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style>
</style>
